var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg50PxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1863 15.2515H10V26.1189H18.1506V19.2157C18.1506 18.1644 17.7329 17.156 16.9895 16.4126C16.246 15.6691 15.2377 15.2515 14.1863 15.2515V15.2515Z",
    fill: "#004EA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.70454H24.9432C31.6898 1.70454 37.1591 7.17378 37.1591 13.9204V13.9204C37.1591 20.6671 31.6898 26.1364 24.9432 26.1364H10V1.70454Z",
    fill: "#003673"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.0227V16.0227C14.5187 16.0227 18.1818 19.6859 18.1818 24.2045V45.9091C18.1818 48.1684 16.3503 50 14.0909 50V50C11.8316 50 10 48.1684 10 45.9091V16.0227Z",
    fill: "#0B6D5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.0227V26.1363H18.1818V24.2045C18.1818 19.6859 14.5187 16.0227 10 16.0227Z",
    fill: "#0B6D5E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6023,
    cy: 5.85227,
    r: 5.85227,
    fill: "#E1EADF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6945 2.66298C33.2861 4.18074 36.0006 7.36708 36.8664 11.2504C36.1699 11.5429 35.405 11.7045 34.6023 11.7045C31.3702 11.7045 28.75 9.08432 28.75 5.8522C28.75 4.67578 29.0971 3.58043 29.6945 2.66298Z",
    fill: "#FA7861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50PxLogo);
export default __webpack_public_path__ + "static/media/50px_logo.be1a97cb973d715b4b87551172f516d3.svg";
export { ForwardRef as ReactComponent };